import { uniqueId } from 'lodash'
import { DefaultBodyType, PathParams, ResponseResolver, RestContext, RestRequest } from 'msw'

import { PostGlobalNoteBody } from 'core/data/globalNoteQueries/usePostGlobalNote'

import { mswResponseHandler } from '../helpers/mswResponseHandler'

/** @deprecated Use the auto-generated hooks under core/types or if needed create a new hook under core/types/hooks */
export interface PutGlobalNoteBody {
  status?: string
  content: string
  important?: boolean
  sensitiveData?: boolean
  archived?: boolean
  taskableInstruction?: boolean
}

const mockResponse = async (req: RestRequest<any, PathParams<string>>) => {
  const body = await req.json<PutGlobalNoteBody | PostGlobalNoteBody>()
  return {
    content: body.content || '',
    important: body.important || false,
    sensitiveData: body.sensitiveData || false,
    archived: body.archived || false,
    taskableInstruction: body.taskableInstruction || false,
    id: req.params.id || uniqueId('NT-'),
    supercaseId: req.params.supercaseId,
    archivedAt: null,
    archivedBy: null,
    caseId: null,
    category: 'generic',
    createdAt: '2022-12-02T21:53:33.896249+00:00',
    createdBy: {
      id: 'UR-2KE4-7GJM',
      name: 'Dan Mowchan',
    },
    deletedAt: null,
    deletedBy: null,
    edited: false,
    object: 'note',
    oldContent: [],
    status: 'active',
    type: 'supercaseGlobalNote',
    updatedAt: null,
    updatedBy: null,
  }
}

export const resolvePostCaseNote: ResponseResolver<
  RestRequest<any, PathParams<string>>,
  RestContext,
  DefaultBodyType
> = async (req, res, ctx) => {
  return mswResponseHandler({
    ctx,
    res,
    id: 'postCaseNote',
    data: mockResponse(req),
  })
}

export const resolvePutCaseNote: ResponseResolver<
  RestRequest<any, PathParams<string>>,
  RestContext,
  DefaultBodyType
> = async (req, res, ctx) => {
  return mswResponseHandler({
    ctx,
    res,
    id: 'putCaseNote',
    data: mockResponse(req),
  })
}

export const resolvePostLocalNote: ResponseResolver<
  RestRequest<any, PathParams<string>>,
  RestContext,
  DefaultBodyType
> = async (req, res, ctx) => {
  return mswResponseHandler({
    ctx,
    res,
    id: 'postSupercaseLocalNote',
    data: mockResponse(req),
  })
}

export const resolvePutLocalNote: ResponseResolver<
  RestRequest<any, PathParams<string>>,
  RestContext,
  DefaultBodyType
> = async (req, res, ctx) => {
  return mswResponseHandler({
    ctx,
    res,
    id: 'putSupercaseLocalNote',
    data: mockResponse(req),
  })
}

export const resolvePostGlobalNote: ResponseResolver<
  RestRequest<any, PathParams<string>>,
  RestContext,
  DefaultBodyType
> = async (req, res, ctx) => {
  return mswResponseHandler({
    ctx,
    res,
    id: 'postSupercaseGlobalNote',
    data: mockResponse(req),
  })
}

export const resolvePutGlobalNote: ResponseResolver<
  RestRequest<any, PathParams<string>>,
  RestContext,
  DefaultBodyType
> = async (req, res, ctx) => {
  return mswResponseHandler({
    ctx,
    res,
    id: 'putSupercaseGlobalNote',
    data: mockResponse(req),
  })
}
